export default __webpack_public_path__ + "locales/ar-SA/EmptyTrashDialog.json?hash=a62bcf4a929b2f439d999b7e4d67c2b9";